import { render, staticRenderFns } from "./TransactionStatus.vue?vue&type=template&id=095e76c8"
import script from "./TransactionStatus.vue?vue&type=script&lang=js"
export * from "./TransactionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports